import React from "react";
import LocalizedStrings from "react-localization";
import AppString from "settings/AlexaAppContext.json";

export const strings = new LocalizedStrings({
  [AppString.en_US]: {
    alexa: "ALEXA",
    audio: "AUDIO",
    language: "ALEXA SPEECH LANGUAGE",
    inputDevice: "Input Device",
    activateShortcut: "Activate Alexa",
    setRespond: "Set the language that Alexa will use to listen and respond.",
    account: "ACCOUNT",
    signOut: "Log Out",
    doNotDisturb: "DO NOT DISTURB",
    doNotDisturbDetail1:
      "Turn off all sound, status notifications and display cards.",
    settings: "SETTINGS",
    skills: "SKILLS",
    home: "HOME",
    noNetwork: "No network connectivity detected.",
    speaking: "Speaking",
    micOff: "Mic Off",
    thinking: "Thinking",
    noMic: "No Mic",
    listening: "Listening",
    sessionTimeout: "Session timeout. ",
    loginToContinue: "Please login to continue.",
    stopResponse: "Stop response",
    StopAndCloseWindow: "Stop and close this window",
    alexaButton: "Alexa button",
    synapseSkill: "SYNAPSE SKILL",
    synapseSkillDetail:
      "With the Synapse skill and Alexa, you now have the ability control your computer as well as Razer Chroma devices with just your voice.",
    synapseSkill1: "CUSTOM SKILLS",
    synapseSkillDetail1:
      'We recommended navigating to the Razer Skill by saying "Open Razer" followed by the one of the skills below.',
    synapseSkill2: "SMART HOME SKILLS",
    synapseSkillDetail2:
      'A device "Chroma Lighting" will be available on the Alexa app.<br/>These skills can be activated by simply saying “Alexa” followed by the command with the “Chroma Lighting” device name.',
    basicLightingControls: "Basic Lighting Controls",
    basicLightingControlsDetail1:
      'You can turn devices on/off, for example "Turn on Chroma Lighting"',
    expandText: "More Skills",
    chromaLightingControls: "Chroma Lighting Controls",
    chromaLightingControlsDetail3:
      'You can quickly switch between your Chroma Effects, for example, "Switch to the next Chroma Studio Effect"',
    closeText: "Close",
    LaunchApplication: "Launch Application",
    LaunChApplicationSubTitle:
      'You can launch applications, for example, "Launch Calculator"',
    launchApplicationDetail1:
      "Supported application include web browser, media player, task manager, snipping tool, paint, notepad, calculator",
    MultimediaControls: "Multimedia Controls",
    MultimediaControlsDetail1:
      'You can increase/decrease volume, for example, "Change volume to 50%"',
    basicLightingControlsDetail2:
      'You can change the brightness to dim/brighten or set to a specific value, for example:  "Dim Chroma Lighting to 50%"',
    chromaLightingControlsDetail1:
      'You can set a basic effect color, for example: "Set Chroma Lighting to Breathing Green" or "Set Chroma Lighting to Spectrum Cycling"',
    chromaLightingControlsDetail2:
      'You can switch to your Chroma Effect created in Chroma Studio, for example, "Set Chroma Lighting to Chroma Studio Effect 1"',
    chromaLightingControlsDetail4:
      'You can turn on/off Chroma Visualizer, for example "Turn on Chroma Visualizer"',
    chromaLightingControlsDetail5:
      'You can start a Chroma Party, say "Start a Chroma Party"',
    MultimediaControlsDetail2:
      'You can mute/unmute volume, for example, "Mute volume"',
    MultimediaControlsDetail3:
      'You can mute/unmute microphone, for example, "Mute microphone"',
    MultimediaControlsDetail4:
      'You can increase/decrease microphone volume, for example, "Change microphone volume to 50%"',
    PowerControls: "Power",
    PowerControlsDetail:
      'You can shutdown or lock your computer, for example, "Shutdown my PC"',
    smartHomeSkillsControls: "Smart Home Skills",
    smartHomeSkillsControlsDetail:
      'You can quickly set Chroma Lighting to any effect or color, for example, "Set <b>Chroma Lighting Effect</b> to <b>Static Green</b>"',
    smartHomeSkillsControlsDetail1:
      '"Set Chroma Lighting Effect to Static (Green)"',
    smartHomeSkillsControlsDetail2:
      '"Set Chroma Lighting Effect to Spectrum Cycling"',
    smartHomeSkillsControlsDetail3: '"Set Chroma Lighting Brightness to (50%)"',
    smartHomeSkillsControlsDetail4:
      '"Increase/Decrease Chroma Lighting Brightness"',
    smartHomeSkillsControlsDetail5: '"Turn Chroma Lighting On/Off"',
    canUseAlexa: "You may now use Alexa.",
    someThingToTry: "Here are some things to try:",
    someThingToTryDetail1: '"What\'s the weather?" ',
    someThingToTryDetail2: '"Set Chroma Lighting Brightness to 50%"',
    someThingToTryDetail3: '"Set Chroma Lighting Effect to Spectrum Cycling"',
    someThingToTryDetail4: '"How tall is Mt. Everest?"',
    someThingToTryDetail5: '"Ask Razer to open web browser"',
    someThingToTryDetail6: '"Ask Razer to lock my PC"',
    someThingToTryDetail7: '"Tell Razer to start a Chroma Party"',
    notLoginSubTitleLine1:
      "Alexa allows you to use your voice to play music and get news, sports, scores, weather and more.",
    notLoginSubTitleLine2: "All you have to do is ask Alexa.",
    wheneverCommands:
      "Whenever you're ready, click on the Alexa button located just beside your avatar to ask questions or give commands.",
    canUseAlexaHotkeyToActivate:
      " You may also use the default shortcut Ctrl + Shift + A to activate Alexa. ",
    settingsToolTip1:
      "Change Alexa's settings such as its app sounds and visual content, activation shortcut, display language, and recognized input device.",
    settingsToolTip2:
      "Note: Disabling Alexa will stop Alexa from listening and speaking on this device.",
    settingsToolTip3:
      "Synapse Skills will remain active even when Alexa is disabled.",
    loginWithAlexa: "LOGIN WITH AMAZON",
    notUserFront: "Not",
    notUserBack: "?",
    appSound: "App Sounds",
    displayCard: "Display Cards",
    razerIDRequired: "A RAZER ID IS REQUIRED",
    mustLogin: "You must log in with your Razer ID to use this module.",
    logIn: "LOG IN",
    isEnableWakeWord: 'With your voice by saying the wake word "Alexa"',
    isEnableShortCut: "With a keyboard shortcut",
    accountLinkingConflictsDialogParam1:
      "This Amazon account has already been linked with a different Razer account. Account linking is required to allow Alexa to control your Razer Synapse though an Alexa-enabled device.",
    accountLinkingConflictsDialogParam2:
      "Note: Pressing allow would remove the existing razer account linked on your Amazon account.",
    accountLinkingConflictsDialogOK: "ALLOW",
    accountLinkingConflictsDialogCancel: "CANCEL",
    loginSessionExpireLine1: "Login session ended.",
    loginSessionExpireLine2:
      "The Amazon account has been logged in elsewhere with a different Razer account",
    SupportedRegions: "Supported Regions",
    VoiceNote:
      "Note: Voice recognition improves when using Amazon certified input devices.",
    AlexaGuide: "Alexa Guide & FAQ",
    CodebasedLinking: {
      instruction1: "Go to",
      instruction2:
        "on your smartphone, computer, or tablet and enter this code:",
    },
  },
  [AppString.zh_CHS]: {
    alexa: "ALEXA",
    audio: "音频",
    language: "ALEXA 沟通语言",
    inputDevice: "输入设备",
    activateShortcut: "激活 Alexa 快捷方式",
    setRespond: "为 Alexa 设置听取和回复的语言。",
    account: "账号",
    signOut: "注销",
    doNotDisturb: "勿扰",
    doNotDisturbDetail1: "关闭所有声音、状态通知和显示卡。",
    settings: "设置",
    skills: "技能",
    home: "首页",
    noNetwork: "未检测到网络连接。",
    speaking: "回应",
    micOff: "关闭麦克风",
    thinking: "思考",
    noMic: "无麦克风",
    listening: "倾听",
    sessionTimeout: "会话超时。 ",
    loginToContinue: "请登录再继续。",
    stopResponse: "停止回应",
    StopAndCloseWindow: "停止并关闭此窗口",
    alexaButton: "Alexa 按钮",
    synapseSkill: "SYNAPSE 雷云技能",
    synapseSkillDetail:
      "现在，你可以借助 Synapse 雷云技能和 Alexa，用声音控制你的电脑和 Razer Chroma 雷蛇幻彩设备。",
    synapseSkill1: "自定义技能",
    synapseSkillDetail1:
      "我们建议先说“打开雷蛇”，然后再讲以下其中一项技能，就可以导航至 Razer 雷蛇技能。",
    synapseSkill2: "智能家居技能",
    synapseSkillDetail2:
      "Alexa 应用中将有一个名为“Chroma 幻彩灯光效果”的设备。<br/>你只需说“Alexa”，然后说出带有“Chroma 幻彩灯光效果”设备名称的命令，即可激活这些技能。",
    basicLightingControls: "基本灯光控制",
    basicLightingControlsDetail1:
      "你可以打开或关闭设备，例如“启用 Chroma 幻彩灯光效果”",
    expandText: "更多技能",
    chromaLightingControls: "Chroma 幻彩灯光控制",
    chromaLightingControlsDetail3:
      "你可以在 Chroma 幻彩灯光效果之间快速切换，例如“切换至下一个幻彩控制室 (Chroma Studio) 效果”",
    closeText: "关闭",
    LaunchApplication: "启动应用程序",
    LaunChApplicationSubTitle: "你可以启动应用程序，例如“启动计算器”",
    launchApplicationDetail1:
      "支持的应用程序包括网页浏览器、媒体播放器、任务管理器、截图工具、绘画、记事本、计算器",
    MultimediaControls: "多媒体控制",
    MultimediaControlsDetail1: "你可以调高或调低音量，例如“把音量降至 50%”",
    basicLightingControlsDetail2:
      "你可以将亮度更改为暗淡或明亮，或设置为特定值，例如：  “将 Chroma 幻彩灯光效果的亮度降至 50%”",
    chromaLightingControlsDetail1:
      "你可以设置基本灯光效果的颜色，例如：“将 Chroma 幻彩灯光设置为绿色的呼吸效果”或“将 Chroma 幻彩灯光设置为光谱循环效果”",
    chromaLightingControlsDetail2:
      "你可以切换为你在幻彩控制室 (Chroma Studio) 中创建的 Chroma 幻彩效果，例如“将 Chroma 幻彩灯光设置为幻彩控制室 (Chroma Studio) 效果 1”",
    chromaLightingControlsDetail4:
      "你可以打开或关闭幻彩可视化工具 (Chroma Visualizer)，例如“打开幻彩可视化工具 (Chroma Visualizer)”",
    chromaLightingControlsDetail5:
      "你可以开始一个 Chroma 幻彩派对，只需说“开始 Chroma 幻彩派对”",
    MultimediaControlsDetail2: "你可以将音量静音或取消静音，例如“静音”",
    MultimediaControlsDetail3: "你可以将麦克风静音或取消静音，例如“静音麦克风”",
    MultimediaControlsDetail4:
      "你可以调高或调低麦克风音量，例如“把麦克风音量调整为 50%”",
    PowerControls: "电源",
    PowerControlsDetail: "你可以关闭或锁定电脑，例如“关闭我的电脑”",
    smartHomeSkillsControls: "智能家居技能",
    smartHomeSkillsControlsDetail:
      "你可以快速将“Chroma 幻彩灯光效果”设置为任何效果或色彩，例如 “将 <b>Chroma 幻彩灯光效果</b>设置为<b>常亮（绿色）</b>”",
    smartHomeSkillsControlsDetail1:
      "“将 Chroma 幻彩灯光效果设置为常亮（绿色）”",
    smartHomeSkillsControlsDetail2: "“将 Chroma 幻彩灯光效果设置为光谱循环”",
    smartHomeSkillsControlsDetail3:
      "“将 Chroma 幻彩灯光效果的亮度设置为 (50%)”",
    smartHomeSkillsControlsDetail4: "“提高/降低 Chroma 幻彩灯光效果的亮度”",
    smartHomeSkillsControlsDetail5: "“打开/关闭 Chroma 幻彩灯光效果”",
    canUseAlexa: "现在，Alexa 已经准备就绪。",
    someThingToTry: "你可以尝试以下语音内容：",
    someThingToTryDetail1: "“天气如何？” ",
    someThingToTryDetail2: "“将 Chroma 幻彩灯光效果的亮度设置为 50”",
    someThingToTryDetail3: "“将 Chroma 幻彩灯光效果设置为光谱循环”",
    someThingToTryDetail4: "“珠穆朗玛峰的高度是多少？”",
    someThingToTryDetail5: "“请 Razer 雷蛇打开网页浏览器”",
    someThingToTryDetail6: "“请 Razer 雷蛇锁定我的电脑”",
    someThingToTryDetail7: "“告诉 Razer 雷蛇开始一个 Chroma 幻彩派对”",
    notLoginSubTitleLine1:
      "借助 Alexa，你只需通过语音即可播放音乐，并了解新闻、体育赛事、得分情况以及天气等信息。",
    notLoginSubTitleLine2: "你所要做的就是询问 Alexa。",
    wheneverCommands:
      "无论何时，只要你需要，即可点击头像旁边的 Alexa 按钮来提出问题或发出指令。",
    canUseAlexaHotkeyToActivate:
      " 你也可以使用默认的快捷键（Ctrl + Shift + A）来激活 Alexa。 ",
    settingsToolTip1:
      "更改 Alexa 的设置，例如应用程序声音和可视内容、激活快捷方式、显示语言和已识别的输入设备等。",
    settingsToolTip2:
      "注意：如果禁用 Alexa，则 Alexa 将无法通过此设备接听任何内容或作出回应。即使 Alexa 已禁用，",
    settingsToolTip3: "Synapse 雷云技能仍会保持活跃状态。",
    loginWithAlexa: "用亚马逊账户登录",
    notUserFront: "并非 ",
    notUserBack: "？",
    appSound: "应用程序声音",
    displayCard: "显示卡",
    razerIDRequired: "需要 RAZER ID",
    mustLogin: "必须使用 Razer ID 登录后才能使用此模块。",
    logIn: "登录",
    isEnableWakeWord: "通过声音，即说出唤醒词 “Alexa”",
    isEnableShortCut: "通过键盘快捷键",
    accountLinkingConflictsDialogParam1:
      "此亚马逊账号已与其他 Razer 雷蛇账号关联。只有进行账号关联后，Alexa 才能通过支持 Alexa 的设备控制 Razer Synapse 雷云。",
    accountLinkingConflictsDialogParam2:
      "注意：按下“允许”即会删除你的亚马逊账号上当前所关联的 Razer 雷蛇账号。",
    accountLinkingConflictsDialogOK: "允许",
    accountLinkingConflictsDialogCancel: "取消",
    loginSessionExpireLine1: "登录会话已结束。",
    loginSessionExpireLine2:
      "此亚马逊账号已由其他 Razer 雷蛇账号在其他地方登录",
    SupportedRegions: "支持的区域",
    VoiceNote:
      "注意：如果使用 Amazon 认证的输入设备，则语音识别效果会有所提升。",
    AlexaGuide: "Alexa 指南和常见问题解答",
    CodebasedLinking: {
      instruction1: "用智能手机、电脑或平板电脑访问",
      instruction2: "并输入以下验证码",
    },
  },
  [AppString.zh_CHT]: {
    alexa: "ALEXA",
    audio: "音訊",
    language: "ALEXA 語音語言",
    inputDevice: "輸入裝置",
    activateShortcut: "啟用 Alexa 捷徑",
    setRespond: "設定 Alexa 聆聽與回應的語言。",
    account: "帳號",
    signOut: "登出",
    doNotDisturb: "勿擾模式",
    doNotDisturbDetail1: "關閉所有音效、狀態通知與顯示卡片。",
    settings: "設定",
    skills: "技能",
    home: "首頁",
    noNetwork: "未偵測到網路連線。",
    speaking: "正在說話",
    micOff: "麥克風關閉",
    thinking: "正在思考",
    noMic: "無麥克風",
    listening: "正在聆聽",
    sessionTimeout: "工作階段逾時。 ",
    loginToContinue: "請登入以繼續。",
    stopResponse: "停止回應",
    StopAndCloseWindow: "停止並關閉視窗",
    alexaButton: "Alexa 按鈕",
    synapseSkill: "SYNAPSE 技能",
    synapseSkillDetail:
      "有了 Synapse 技能和 Alexa，你現在可以使用聲音操控電腦與 Razer Chroma 裝置。",
    synapseSkill1: "自訂技能",
    synapseSkillDetail1:
      "若要瀏覽至 Razer 技能，建議你先說：「開啟 Razer」，然後再說出下列其中一項技能。",
    synapseSkill2: "智慧家庭技能",
    synapseSkillDetail2:
      "Alexa 應用程式上將會出現一個裝置的「Chrome 燈光」。 <br/>若要啟用這些技能，只要說：「Alexa」，然後在命令中包含具有「Chrome 燈光」的裝置名稱即可。",
    basicLightingControls: "基本燈光控制",
    basicLightingControlsDetail1:
      "你可以開啟/關閉裝置，例如說：「開啟 Chroma 燈光」",
    expandText: "更多技能",
    chromaLightingControls: "Chroma 燈光控制",
    chromaLightingControlsDetail3:
      "你可以快速切換 Chroma 效果，例如說：「切換至下一個 Chroma Studio 效果」",
    closeText: "關閉",
    LaunchApplication: "啟動應用程式",
    LaunChApplicationSubTitle: "你可以啟動應用程式，例如說：「啟動計算機」",
    launchApplicationDetail1:
      "支援的應用程式包括網頁瀏覽器、媒體播放器、工作管理員、截圖工具、小畫家、記事本、小算盤",
    MultimediaControls: "多媒體控制",
    MultimediaControlsDetail1:
      "你可以提高/降低音量，例如說：「將音量降低至 50%」",
    basicLightingControlsDetail2:
      "你可以將亮度調暗/調亮，或設為特定亮度，例如說：  「將 Chroma 亮度調暗到 50%」",
    chromaLightingControlsDetail1:
      "你可以設定基本的效果色彩，例如說：「將 Chroma 燈光設為綠色呼吸效果」或「將 Chroma 燈光設為光譜循環效果」",
    chromaLightingControlsDetail2:
      "你可以改用在 Chroma Studio 當中建立的 Chroma 效果，例如說：「將 Chroma 燈光設為 Chroma Studio 效果 1」",
    chromaLightingControlsDetail4:
      "你可以開啟/關閉 Chroma Visualizer，例如說「開啟 Chroma Visualizer」",
    chromaLightingControlsDetail5:
      "你可以開始 Chroma 派對，說：「開始 Chroma 派對」",
    MultimediaControlsDetail2: "你可以靜音/取消靜音，例如說：「靜音」",
    MultimediaControlsDetail3:
      "你可以靜音/取消靜音麥克風，例如說：「麥克風靜音」",
    MultimediaControlsDetail4:
      "你可以提高/降低麥克風音量，例如說：「將麥克風音量變更至 50%」",
    PowerControls: "電源",
    PowerControlsDetail: "你可以關閉或鎖定電腦，例如說：「關閉我的電腦」。",
    smartHomeSkillsControls: "智慧家庭技能",
    smartHomeSkillsControlsDetail:
      "你可以快速將 Chroma 燈光設為任何效果或顏色。例如說：「設定 <b>Chroma 燈光效果</b>為<b>恆亮綠光</b>」",
    smartHomeSkillsControlsDetail1: "「設定 Chroma 燈光效果為恆亮綠光」",
    smartHomeSkillsControlsDetail2: "「設定 Chroma 燈光效果為光譜循環」",
    smartHomeSkillsControlsDetail3: "「設定 Chroma 燈光亮度為 (50%)」",
    smartHomeSkillsControlsDetail4: "「提高/降低 Chroma 燈光亮度」",
    smartHomeSkillsControlsDetail5: "「開啟/關閉 Chroma 燈光」",
    canUseAlexa: "你現在可以開始使用 Alexa。",
    someThingToTry: "以下是你可以試試看的指令：",
    someThingToTryDetail1: "「天氣如何？」 ",
    someThingToTryDetail2: "「設定 Chroma 燈光亮度為 50%」",
    someThingToTryDetail3: "「設定 Chroma 燈光效果為光譜循環」",
    someThingToTryDetail4: "「聖母峰有多高？」",
    someThingToTryDetail5: "「叫 Razer 開啟網頁瀏覽器」",
    someThingToTryDetail6: "「叫 Razer 鎖定我的電腦」",
    someThingToTryDetail7: "「要求 Razer 開始一個 Chroma Party」",
    notLoginSubTitleLine1:
      "Alexa 讓你能使用聲音播放音樂，並取得新聞、運動賽事、比分與天氣等最新內容。",
    notLoginSubTitleLine2: "你只需要開口問 Alexa。",
    wheneverCommands:
      "只要你準備好，就可以按一下你的頭像旁的 Alexa 按鈕來問問題或下指令。",
    canUseAlexaHotkeyToActivate:
      " 你也可使用預設捷徑 Ctrl + Shift + A 來啟用 Alexa。 ",
    settingsToolTip1:
      "變更 Alexa 的設定，例如其應用程式音效與視覺內容、啟用捷徑、顯示語言，以及已辨識的輸入裝置等。",
    settingsToolTip2:
      "注意：停用 Alexa 後，Alexa 將不會透過此裝置聆聽或發言。即使停用 Alexa，",
    settingsToolTip3: "依然會啟用「Synapse 技能」",
    loginWithAlexa: "使用 AMAZON 帳戶登入",
    notUserFront: "不是 ",
    notUserBack: "嗎？",
    appSound: "應用程式音效",
    displayCard: "顯示畫面",
    razerIDRequired: "必須使用 RAZER ID",
    mustLogin: "你必須使用你的 Razer ID 登入，才能使用此模組。",
    logIn: "登入",
    isEnableWakeWord: "用你的聲音說出喚醒字「Alexa」",
    isEnableShortCut: "使用鍵盤快捷鍵",
    accountLinkingConflictsDialogParam1:
      "這個 Amazon 帳戶已連結至另一個 Razer 帳戶。必須連結帳戶才可讓 Alexa 透過支援 Alexa 的裝置來控制你的 Razer Synapse。",
    accountLinkingConflictsDialogParam2:
      "注意：按下「允許」會移除已連結至你 Amazon 帳戶的現有 Razer 帳戶。",
    accountLinkingConflictsDialogOK: "允許",
    accountLinkingConflictsDialogCancel: "取消",
    loginSessionExpireLine1: "已結束登入程序。",
    loginSessionExpireLine2: "不同的 Razer 帳戶已在其他位置登入此 Amazon 帳戶",
    SupportedRegions: "支援的區域",
    VoiceNote: "注意：使用經 Amazon 認證的輸入裝置時，語音辨識功能效果更好。",
    AlexaGuide: "Alexa 指南與常見問題集",
    CodebasedLinking: {
      instruction1: "請使用你的智慧型手機、電腦或平板電腦造訪",
      instruction2: "，接著輸入此驗證碼",
    },
  },
  [AppString.ru_RU]: {
    alexa: "ALEXA",
    audio: "АУДИО",
    language: "ЯЗЫК ALEXA",
    inputDevice: "Устройство ввода",
    activateShortcut: "Сочетание клавиш для активации Alexa",
    setRespond:
      "Установка языка, который Alexa будет использовать для распознавания реплик и произнесения ответов.",
    account: "АККАУНТ",
    signOut: "Выйти",
    doNotDisturb: "НЕ БЕСПОКОИТЬ",
    doNotDisturbDetail1:
      "Выключение всех звуков, уведомлений о состояниях и видеоадаптеров.",
    settings: "НАСТРОЙКИ",
    skills: "НАВЫКИ",
    home: "ДОМ",
    noNetwork: "Подключение к сети не обнаружено.",
    speaking: "Говорит",
    micOff: "Микрофон ВЫКЛ",
    thinking: "Думает",
    noMic: "Микрофон отсутствует",
    listening: "Слушает",
    sessionTimeout: "Сеанс истек. ",
    loginToContinue: "Для продолжения войдите в систему.",
    stopResponse: "Остановить ответ",
    StopAndCloseWindow: "Остановить и закрыть данное окно",
    alexaButton: "Кнопка Alexa",
    synapseSkill: "НАВЫК SYNAPSE",
    synapseSkillDetail:
      "Благодаря навыкам Synapse и Alexa у вас появляется возможность управлять компьютером и устройствами Razer Chroma, используя лишь свой голос.",
    synapseSkill1: "ПОЛЬЗОВАТЕЛЬСКИЕ НАВЫКИ",
    synapseSkillDetail1:
      "Рекомендуется перейти в навыки Razer, сказав «Открой Razer», после чего можно воспользоваться одним из навыков, описанных ниже.",
    synapseSkill2: "НАВЫКИ ДЛЯ УМНОГО ДОМА",
    synapseSkillDetail2:
      "Устройство «Подсветка Chroma» будет доступна в приложении Alexa. <br/>Чтобы активировать эти навыки, скажите «Alexa», а затем произнесите команду, добавив название устройства «Подсветка Chroma».",
    basicLightingControls: "Базовое управление подсветкой",
    basicLightingControlsDetail1:
      "Можно включать или выключать устройства, например: «Включи подсветку Chroma»",
    expandText: "Дополнительные навыки",
    chromaLightingControls: "Управление подсветкой Chroma",
    chromaLightingControlsDetail3:
      "Можно быстро переключаться между эффектами Chroma, например: «Включи следующий эффект Chroma Studio»",
    closeText: "Закрыть",
    LaunchApplication: "Запуск приложений",
    LaunChApplicationSubTitle:
      "Можно запускать приложения, например: «Запусти калькулятор»",
    launchApplicationDetail1:
      "Поддерживаются следующие приложения: веб-браузер, медиапроигрыватель, диспетчер задач, ножницы, Paint, блокнот, калькулятор.",
    MultimediaControls: "Управление мультимедиа",
    MultimediaControlsDetail1:
      "Можно увеличивать или уменьшать громкость, например: «Уменьши громкость до 50%»",
    basicLightingControlsDetail2:
      "Можно уменьшать или увеличивать яркость, а также устанавливать определенное значение яркости, например:  «Убавь яркость подсветки Chroma до 50%»",
    chromaLightingControlsDetail1:
      "Можно устанавливать цвет основного эффекта, например: «Установи подсветку Chroma на зеленый эффект дыхания» или «Установи подсветку Chroma на циклическое переключение цветов спектра»",
    chromaLightingControlsDetail2:
      "Можно переключаться на свои эффекты Chroma, созданные в Chroma Studio, например: «Установи подсветку Chroma на эффект 1 Chroma Studio»",
    chromaLightingControlsDetail4:
      "Можно включать или выключать Chroma Visualizer, например: «Включи Chroma Visualizer»",
    chromaLightingControlsDetail5:
      "Можно включать вечеринку Chroma, например: «Включи вечеринку Chroma»",
    MultimediaControlsDetail2:
      "Можно выключать или включать звук, например: «Выключи звук»",
    MultimediaControlsDetail3:
      "Можно выключать или включать микрофон, например: «Выключи микрофон»",
    MultimediaControlsDetail4:
      "Можно повысить или понизить громкость микрофона, сказав, например: «Измени громкость микрофона до 50%».",
    PowerControls: "Питание",
    PowerControlsDetail:
      "Можно выключить или заблокировать компьютер, сказав, например, «Выключи мой компьютер».",
    smartHomeSkillsControls: "Навыки для умного дома",
    smartHomeSkillsControlsDetail:
      "Для подсветки Chroma можно быстро установить любой эффект или цвет. Пример команды: «Установи для <b>подсветки Chroma статический зеленый эффект</b>»",
    smartHomeSkillsControlsDetail1:
      "«Установи для подсветки Chroma статический эффект (зеленый)»",
    smartHomeSkillsControlsDetail2:
      "«Установи для подсветки Chroma цикличную смену спектра»",
    smartHomeSkillsControlsDetail3:
      "«Установи яркость подсветки Chroma на 50%»",
    smartHomeSkillsControlsDetail4:
      "«Увеличение/уменьшение яркости подсветки Chroma»",
    smartHomeSkillsControlsDetail5: "«Включение/выключение подсветки Chroma»",
    canUseAlexa: "Теперь можно использовать Alexa.",
    someThingToTry: "Вот несколько фраз, которые можно опробовать:",
    someThingToTryDetail1: "«Какая сейчас погода?» ",
    someThingToTryDetail2: "«Установи яркость подсветки Chroma на 50%»",
    someThingToTryDetail3:
      "«Установи для подсветки Chroma цикличную смену спектра»",
    someThingToTryDetail4: "«Высота горы Эверест?»",
    someThingToTryDetail5: "«Попроси Razer открыть веб-браузер»",
    someThingToTryDetail6: "«Попроси Razer заблокировать мой компьютер»",
    someThingToTryDetail7: "«Попроси Razer начать вечеринку Chroma»",
    notLoginSubTitleLine1:
      "Alexa позволяет использовать голосовые команды, чтобы управлять воспроизведением музыки, получать сводки новостей, узнавать о новостях спорта, результатах матчей, о погоде, а также выполнять множество других действий.",
    notLoginSubTitleLine2: "Вам требуется только спросить Alexa.",
    wheneverCommands:
      "В любой удобный момент нажмите кнопку Alexa, расположенную рядом со своим аватаром, чтобы задать вопрос или отдать команду.",
    canUseAlexaHotkeyToActivate:
      " Чтобы активировать Alexa, также можно использовать установленное по умолчанию сочетание клавиш Ctrl + Shift + A. ",
    settingsToolTip1:
      "Изменение настроек Alexa, таких как звуки приложения и визуальное содержимое, сочетание клавиш для активации, язык отображения и распознанное устройство ввода.",
    settingsToolTip2:
      "Примечание. Выключение Alexa приведет к прекращению работы функций Alexa по распознаванию голоса и воспроизведению реплик на данном устройстве. ",
    settingsToolTip3:
      "Навыки Synapse продолжат работать даже после выключения Alexa.",
    loginWithAlexa: "ВОЙТИ С ПОМОЩЬЮ AMAZON",
    notUserFront: "Не ",
    notUserBack: "?",
    appSound: "Звуки приложения",
    displayCard: "Визуальные карточки",
    razerIDRequired: "ТРЕБУЕТСЯ RAZER ID",
    mustLogin:
      "Для использования данного модуля необходимо войти с использованием своего Razer ID.",
    logIn: "ВОЙТИ",
    isEnableWakeWord: "С помощью голоса, произнеся кодовое слово «Alexa»",
    isEnableShortCut: "С помощью сочетания клавиш",
    accountLinkingConflictsDialogParam1:
      "Эта учетная запись Amazon уже привязана к другой учетной записи Razer. Для управления Razer Synapse с помощью устройства с поддержкой виртуального ассистента Alexa требуется привязать учетную запись.",
    accountLinkingConflictsDialogParam2:
      "Примечание. Нажатие кнопки «Разрешить» приведет к удалению существующей привязки учетной записи Razer к учетной записи Amazon.",
    accountLinkingConflictsDialogOK: "РАЗРЕШИТЬ",
    accountLinkingConflictsDialogCancel: "ОТМЕНА",
    loginSessionExpireLine1: "Сеанс авторизации завершен.",
    loginSessionExpireLine2:
      "Данная учетная запись Amazon уже авторизована на другом устройстве с использованием другой учетной записи Razer",
    SupportedRegions: "Поддерживаемые регионы",
    VoiceNote:
      "Примечание. Распознавание голоса или речи улучшается при использовании сертифицированных устройств ввода данных Amazon.",
    AlexaGuide: "Руководство по Alexa и часто задаваемые вопросы",
    CodebasedLinking: {
      instruction1: "Перейдите по адресу",
      instruction2:
        "на своем смартфоне, компьютере или планшете и введите этот код:",
    },
  },
  [AppString.pt_BR]: {
    alexa: "ALEXA",
    audio: "ÁUDIO",
    language: "IDIOMA DE FALA DE ALEXA",
    inputDevice: "Dispositivo de entrada",
    activateShortcut: "Ativar atalho para a Alexa",
    setRespond:
      "Definir o idioma que a Alexa utilizará para ouvir e responder.",
    account: "CONTA",
    signOut: "Encerrar sessão",
    doNotDisturb: "NÃO PERTURBAR",
    doNotDisturbDetail1:
      "Desligar todos os sons, notificações de status e cartões de exibição.",
    settings: "CONFIGURAÇÕES",
    skills: "SKILLS",
    home: "HOME",
    noNetwork: "Nenhuma conectividade de rede detectada.",
    speaking: "Falar",
    micOff: "Microfone desligado",
    thinking: "Pensar",
    noMic: "Sem microfone",
    listening: "Ouvir",
    sessionTimeout: "Fim do tempo da sessão. ",
    loginToContinue: "Inicie sessão para continuar.",
    stopResponse: "Interromper resposta",
    StopAndCloseWindow: "Parar e fechar esta janela",
    alexaButton: "Botão Alexa",
    synapseSkill: "SKILL SYNAPSE",
    synapseSkillDetail:
      "Com a skill Synapse e com a Alexa, você agora tem a possibilidade de controlar seu computador, assim como os dispositivos Razer Chroma, apenas com sua voz.",
    synapseSkill1: "PERSONALIZAR SKILLS",
    synapseSkillDetail1:
      "Recomendamos a navegação à Skill Razer dizendo “Abrir Razer” seguido de uma das skills abaixo.",
    synapseSkill2: "SKILLS DE CASA INTELIGENTE",
    synapseSkillDetail2:
      "No aplicativo Alexa, estará disponível um dispositivo com “Iluminação Chroma”. <br/>Essas habilidades podem ser ativadas simplesmente dizendo-se “Alexa”, seguido do comando com o nome do dispositivo com “Iluminação Chroma”.",
    basicLightingControls: "Controles básicos de iluminação",
    basicLightingControlsDetail1:
      "Você pode ligar/desligar dispositivos, por exemplo, “Ligar iluminação Chroma”",
    expandText: "Mais Skills",
    chromaLightingControls: "Controles de iluminação Chroma",
    chromaLightingControlsDetail3:
      "Você pode alternar rapidamente entre seus Efeitos Chroma, por exemplo, “Alternar para o próximo Efeito do Chroma Studio”",
    closeText: "Fechar",
    LaunchApplication: "Abrir aplicativo",
    LaunChApplicationSubTitle:
      "Você pode abrir aplicativos, por exemplo, “Abrir calculadora”",
    launchApplicationDetail1:
      "O aplicativo suportado inclui navegador de internet, reprodutor de mídia, gerenciador de tarefas, ferramenta de recorte, pincel, bloco de notas e calculadora",
    MultimediaControls: "Controles multimídia",
    MultimediaControlsDetail1:
      "Você pode aumentar/diminuir o volume, por exemplo, “Diminuir o volume para 50%”",
    basicLightingControlsDetail2:
      "Você pode alterar a luminosidade para diminuí-la/aumentá-la ou definir um valor específico, por exemplo:  “Diminuir iluminação Chroma para 50%”",
    chromaLightingControlsDetail1:
      "Você pode definir uma cor básica para o efeito, por exemplo: “Definir a iluminação Chroma em Respiração verde” ou “Definir a iluminação Chroma em Ciclo de Espectros”",
    chromaLightingControlsDetail2:
      "Você pode alternar para seu efeito Chroma criado no Chroma Studio, por exemplo, “Definir a iluminação Chroma no Efeito Chroma Studio 1”",
    chromaLightingControlsDetail4:
      "Você pode ligar/desligar o Chroma Visualizer, por exemplo, “Ligar o Chroma Visualizer”",
    chromaLightingControlsDetail5:
      "Você pode iniciar uma festa Chroma dizendo “Iniciar uma festa Chroma”",
    MultimediaControlsDetail2:
      "Você pode silenciar/ativar o volume, por exemplo, “Silenciar volume”",
    MultimediaControlsDetail3:
      "Você pode silenciar/ativar o microfone, por exemplo, “Silenciar microfone”",
    MultimediaControlsDetail4:
      "Você pode aumentar/diminuir o volume do microfone, por exemplo, “Alterar o volume do microfone para 50%”",
    PowerControls: "Ligar/Desligar",
    PowerControlsDetail:
      "Você pode desligar ou bloquear seu computador, por exemplo, “Fechar meu computador”",
    smartHomeSkillsControls: "Skills de Casa Inteligente",
    smartHomeSkillsControlsDetail:
      'É possível definir rapidamente a Iluminação Chroma em qualquer efeito ou cor, por exemplo, "Definir o <b>Efeito de Iluminação Chroma</b> para <b>Verde Estático</b>"',
    smartHomeSkillsControlsDetail1:
      "“Definir o Efeito de Iluminação Chroma em (Verde) Estático”",
    smartHomeSkillsControlsDetail2:
      "“Definir o Efeito de Iluminação Chroma para Ciclo de Espectros”",
    smartHomeSkillsControlsDetail3:
      "“Definir o Brilho da Iluminação Chroma em (50%)”",
    smartHomeSkillsControlsDetail4:
      "“Aumentar/diminuir o Iluminação da Iluminação Chroma”",
    smartHomeSkillsControlsDetail5: '"Ligar/desligar a Iluminação Chroma"',
    canUseAlexa: "Agora, você pode utilizar a Alexa.",
    someThingToTry: "Veja aqui algumas coisas que você pode experimentar:",
    someThingToTryDetail1: "“Como está o clima?” ",
    someThingToTryDetail2: "“Definir o Iluminação da Iluminação Chroma em 50%”",
    someThingToTryDetail3:
      "“Definir o Efeito de Iluminação Chroma para Ciclo de Espectros”",
    someThingToTryDetail4: "“Qual é a altura do Monte Everest?”",
    someThingToTryDetail5: "“Pedir à Razer para abrir o navegador de Internet”",
    someThingToTryDetail6: "“Pedir à Razer para bloquear meu PC”",
    someThingToTryDetail7: "“dizer à Razer para iniciar uma Festa Chroma”",
    notLoginSubTitleLine1:
      "A Alexa permite que você utilize sua voz para reproduzir música e receber atualizações sobre notícias, esportes, placares, previsão do tempo e muito mais.",
    notLoginSubTitleLine2: "Tudo o que você precisa fazer é perguntar à Alexa.",
    wheneverCommands:
      "Quando estiver pronto, clique no botão Alexa, localizado ao lado do seu avatar, para fazer perguntas ou dar comandos.",
    canUseAlexaHotkeyToActivate:
      " Você também pode utilizar o atalho padrão Ctrl + Shift + A para ativar a Alexa. ",
    settingsToolTip1:
      "Alterar as configurações de Alexa, como os sons do seu aplicativo e seu conteúdo visual, o atalho de ativação, o idioma de exibição e o dispositivo de entrada reconhecido.",
    settingsToolTip2:
      "Observação: se desativar Alexa, ela não ouvirá e não falará mais neste dispositivo.",
    settingsToolTip3:
      "As Skills Synapse permanecerão ativas mesmo com Alexa desativada.",
    loginWithAlexa: "FAZER LOGIN COM AMAZON",
    notUserFront: "Não é ",
    notUserBack: "?",
    appSound: "Sons do aplicativo",
    displayCard: "Placas de exibição",
    razerIDRequired: "RAZER ID OBRIGATÓRIO",
    mustLogin:
      "Você deve fazer login com seu Razer ID para utilizar este módulo.",
    logIn: "FAZER LOGIN",
    isEnableWakeWord: 'Com a sua voz, dizendo a senha de ativação "Alexa"',
    isEnableShortCut: "Com um atalho do teclado",
    accountLinkingConflictsDialogParam1:
      "Esta conta da Amazon já foi vinculada a uma conta Razer diferente. A vinculação de conta é necessária para permitir que a Alexa controle seu Razer Synapse através de um dispositivo habilitado para Alexa.",
    accountLinkingConflictsDialogParam2:
      "Observação: Pressionar permitir removeria a conta Razer existente vinculada à sua conta da Amazon.",
    accountLinkingConflictsDialogOK: "PERMITIR",
    accountLinkingConflictsDialogCancel: "CANCELAR",
    loginSessionExpireLine1: "Sessão de login terminada.",
    loginSessionExpireLine2:
      "A conta da Amazon foi conectada em outro lugar com uma conta Razer diferente",
    SupportedRegions: "Regiões suportadas",
    VoiceNote:
      "Observação: O reconhecimento de voz melhora ao se utilizarem dispositivos de entrada certificados pela Amazon.",
    AlexaGuide: "Guia e Perguntas Frequentes de Alexa",
    CodebasedLinking: {
      instruction1: "Acesse",
      instruction2:
        "no seu smartphone, computador ou tablet e insira este código:",
    },
  },
  [AppString.ko_KR]: {
    alexa: "ALEXA",
    audio: "오디오",
    language: "ALEXA 스피치 언어",
    inputDevice: "입력 장치",
    activateShortcut: "Alexa 단축키 활성화",
    setRespond: "Alexa가 듣고 응답할 때 사용할 언어를 설정합니다.",
    account: "계정",
    signOut: "로그아웃",
    doNotDisturb: "방해 금지",
    doNotDisturbDetail1: "소리, 상태 알림, 디스플레이 카드를 모두 끕니다.",
    settings: "설정",
    skills: "스킬",
    home: "HOME",
    noNetwork: "탐지된 네트워크 연결이 없습니다.",
    speaking: "스피커",
    micOff: "마이크 끄기",
    thinking: "생각 중",
    noMic: "마이크 없음",
    listening: "듣는 중",
    sessionTimeout: "세션 시간만료. ",
    loginToContinue: "계속하려면 로그인 하세요.",
    stopResponse: "응답 중지",
    StopAndCloseWindow: "중지 후 창 닫기",
    alexaButton: "Alexa 버튼",
    synapseSkill: "SYNAPSE 스킬",
    synapseSkillDetail:
      "Synapse 스킬과 Alexa를 통해 음성만으로 Razer Chroma 기기처럼 컴퓨터를 제어할 수 있습니다.",
    synapseSkill1: "커스텀 스킬",
    synapseSkillDetail1:
      '"Razer 열어줘"라고 말한 다음, 아래 스킬 중 하나로 Razer 스킬을 탐색하는 것을 권장합니다.',
    synapseSkill2: "스마트 홈 스킬",
    synapseSkillDetail2:
      'Alexa 앱에서 "Chroma 조명" 기기를 사용할 수 있습니다. <br/>이러한 스킬은 "Alexa"라고 말한 다음, 이어서 "Chroma 조명" 기기 이름을 가진 명령을 실행하면 활성화할 수 있습니다.',
    basicLightingControls: "기본 조명 조절 장치",
    basicLightingControlsDetail1:
      '장치를 켜고 끌 수 있습니다. 예컨대 "Chroma 조명 켜"라고 하면 됩니다.',
    expandText: "스킬 더 보기",
    chromaLightingControls: "Chroma 조명 조절 장치",
    chromaLightingControlsDetail3:
      'Chroma Effect를 빠르게 전환할 수 있습니다. 예컨대 "다음 Chroma Studio 효과로 전환"이라고 하면 됩니다.',
    closeText: "닫기",
    LaunchApplication: "시작 애플리케이션",
    LaunChApplicationSubTitle:
      '애플리케이션을 시작할 수 있습니다. 예컨대 "계산기 시작"이라고 하면 됩니다.',
    launchApplicationDetail1:
      "웹 브라우저, 미디어 플레이어, 작업 관리자, 캡처 도구, 그림판, 메모장, 계산기를 포함한 응용 프로그램이 지원됩니다.",
    MultimediaControls: "멀티미디어 조절 장치",
    MultimediaControlsDetail1:
      '볼륨을 높이고 낮출 수 있습니다. 예컨대 "볼륨 50%로 낮춰"라고 하면 됩니다.',
    basicLightingControlsDetail2:
      '명도를 높이 높이거나 낮출 수 있으며 특정 값으로 설정할 수도 있습니다.  예컨대 "Chroma 조명 50%로 낮춰"라고 하면 됩니다.',
    chromaLightingControlsDetail1:
      '기본 이펙트 색을 설정할 수 있습니다. 예컨대 "Chroma 조명 브리딩 녹색으로 설정"이나 "Chroma 조명 스펙트럼 사이클링으로 설정"이라고 하면 됩니다.',
    chromaLightingControlsDetail2:
      'Chroma Studio에서 만든 Chroma 조명 효과로 전환할 수 도 있습니다. 예컨대 "Chroma 조명을 Chroma Studio 이펙트 1로 설정"이라고 하면 됩니다.',
    chromaLightingControlsDetail4:
      'Chroma Visualizer를 켜고 끌 수 있습니다. 예컨대 "Chroma Visualizer 켜"라고 하면 됩니다.',
    chromaLightingControlsDetail5:
      'Chroma 파티를 시작할 수 있습니다. "Chroma 파티 시작"이라고 하면 됩니다.',
    MultimediaControlsDetail2:
      '음소거/취소를 할 수 있습니다. 예컨대 "볼륨 음소거"라고 하면 됩니다.',
    MultimediaControlsDetail3:
      '마이크 음소거/취소를 할 수 있습니다. 예컨대 "마이크 음소거"라고 하면 됩니다.',
    MultimediaControlsDetail4:
      '마이크 볼륨을 높이고 낮출 수 있습니다. 예를 들어, "마이크 볼륨을 50%로 해줘"라고 하면 됩니다.',
    PowerControls: "전원",
    PowerControlsDetail:
      '음성으로 컴퓨터를 종료하거나 잠글 수 있습니다. 예를 들면 "내 PC 꺼줘"라고 할 수 있습니다.',
    smartHomeSkillsControls: "스마트 홈 스킬",
    smartHomeSkillsControlsDetail:
      '어떤 Chroma 조명 효과 또는 색상이든 빠르게 설정할 수 있습니다. 예: "<b>Chroma 조명 효과를 스태틱 그린</b>으로 설정해줘"',
    smartHomeSkillsControlsDetail1:
      '"Chroma 조명 효과를 스태틱 (그린)으로 설정해줘"',
    smartHomeSkillsControlsDetail2:
      '"Chroma 조명 효과를 스펙트럼 사이클링으로 설정해줘"',
    smartHomeSkillsControlsDetail3: '"Chroma 조명 밝기를 (50%)로 설정해줘"',
    smartHomeSkillsControlsDetail4: '"Chroma 조명의 밝기를 높임/낮춤"',
    smartHomeSkillsControlsDetail5: '"Chroma 조명 켜기/끄기"',
    canUseAlexa: "이제 Alexa를 써도 좋습니다.",
    someThingToTry: "몇 가지 시험해 볼까요? ",
    someThingToTryDetail1: '"날씨 어때" ',
    someThingToTryDetail2: '"Chroma 조명 밝기를 50%로 설정해줘"',
    someThingToTryDetail3:
      '"Chroma 조명 효과를 스펙트럼 사이클링으로 설정해줘"',
    someThingToTryDetail4: '"에베레스트산 높이는 얼마야?"',
    someThingToTryDetail5: '"Razer에게 웹 브라우저 열라고 요청해줘"',
    someThingToTryDetail6: '"Razer에게 PC를 잠가 달라고 요청해줘"',
    someThingToTryDetail7: '"Razer에게 Chroma Party를 시작해 달라고 말해줘"',
    notLoginSubTitleLine1:
      "Alexa를 통해 음성으로 음악도 듣고 뉴스, 스포츠, 점수, 날씨 등 최신 소식도 알 수 있습니다.",
    notLoginSubTitleLine2: "Alexa에게 맡기세요.",
    wheneverCommands:
      "아바타 옆 Alexa 버튼을 클릭하고 질문을 하거나 명령을 하면 됩니다.",
    canUseAlexaHotkeyToActivate:
      " 기본 단축키 Ctrl + Shift + A로도 Alexa를 작동할 수 있습니다. ",
    settingsToolTip1:
      "앱 사운드, 시각 콘텐츠, 활성화 단축키, 디스플레이 언어와 인식 입력 장치 등, Alexa의 설정을 변경해보세요.",
    settingsToolTip2:
      "참고: Alexa를 비활성화하면, 장치에서 Alexa가 음성 명령을 듣거나 말하지 않게 됩니다. Alexa를 비활성화하더라도 ",
    settingsToolTip3: "Synapse 스킬은 그대로 활성화 상태가 유지됩니다.",
    loginWithAlexa: "AMAZON으로 로그인",
    notUserFront: "",
    notUserBack: "님이 아니세요?",
    appSound: "앱 사운드",
    displayCard: "디스플레이 카드",
    razerIDRequired: "RAZER ID가 필요합니다",
    mustLogin: "이 모듈을 사용하려면 Razer ID로 로그인해야 합니다.",
    logIn: "로그인",
    isEnableWakeWord: '"Alexa" 라고 소리내 불러서',
    isEnableShortCut: "키보드 단축키로",
    accountLinkingConflictsDialogParam1:
      "이미 다른 Razer 계정과 연결돼 있는 Amazon 계정입니다.  Alexa 지원 장치를 통해 Alexa로 Razer Synapse를 제어하려면 계정 연결이 필요합니다. ",
    accountLinkingConflictsDialogParam2:
      "참고: 누르면 Amazon 계정과 연결돼 있는 기존 Razer 계정이 삭제됩니다.",
    accountLinkingConflictsDialogOK: "허용",
    accountLinkingConflictsDialogCancel: "취소",
    loginSessionExpireLine1: "로그인 세션 종료.",
    loginSessionExpireLine2:
      "이미 다른 Razer 계정으로 다른 곳에 로그인돼 있는 Amazon 계정입니다.",
    SupportedRegions: "지원되는 지역",
    VoiceNote:
      "참고: Amazon 인증 입력 장치를 사용하면 음성 인식 성능이 향상됩니다.",
    AlexaGuide: "Alexa 가이드 및 자주 묻는 질문",
    CodebasedLinking: {
      instruction1: "스마트폰이나 컴퓨터 또는 태블릿에서",
      instruction2: "를 방문하여 이 코드를 입력하십시오",
    },
  },
  [AppString.de_DE]: {
    alexa: "ALEXA",
    audio: "AUDIO",
    language: "ALEXA-SPRACHE",
    inputDevice: "Eingabegerät",
    activateShortcut: "Alexa-Verknüpfung aktivieren",
    setRespond: "Sprache auswählen, auf die Alexa reagieren soll.",
    account: "KONTO",
    signOut: "Abmelden",
    doNotDisturb: "BITTE NICHT STÖREN",
    doNotDisturbDetail1:
      "Alle Sounds, Status-Benachrichtigungen und Einblendungen ausschalten.",
    settings: "EINSTELLUNGEN",
    skills: "SKILLS",
    home: "ZUHAUSE",
    noNetwork: "Es wurde keine Netzwerk-Verbindung erkannt.",
    speaking: "Sprechen",
    micOff: "Mikrofon aus",
    thinking: "Nachdenken",
    noMic: "Kein Mikrofon",
    listening: "Zuhören",
    sessionTimeout: "Sitzung abgelaufen. ",
    loginToContinue: "Zum Fortfahren bitte anmelden.",
    stopResponse: "Antwort stoppen",
    StopAndCloseWindow: "Stoppen und dieses Fenster schließen",
    alexaButton: "Alexa-Taste",
    synapseSkill: "SYNAPSE SKILL",
    synapseSkillDetail:
      "Per Synapse Skill und Alexa kannst du jetzt deinen Computer sowie deine Razer Chroma-Geräte per Stimme steuern.",
    synapseSkill1: "INDIVIDUELLE SKILLS",
    synapseSkillDetail1:
      'Wir empfehlen, den Razer Skill durch den Sprachbefehl "Razer öffnen" gefolgt von einem der folgenden Skills auszuwählen.',
    synapseSkill2: "SMART HOME SKILLS",
    synapseSkillDetail2:
      'Ein Gerät "Chroma-Beleuchtung" wird in der Alexa App verfügbar sein. <br/>Diese Skills kannst du aktivieren, indem du einfach "Alexa" sagst, gefolgt von dem Befehl mit dem Gerätenamen "Chroma-Beleuchtung".',
    basicLightingControls: "Basis-Beleuchtungssteuerung",
    basicLightingControlsDetail1:
      'Du kannst Geräte ein- und ausschalten, zum Beispiel "Chroma-Beleuchtung einschalten"',
    expandText: "Mehr Skills",
    chromaLightingControls: "Chroma-Beleuchtungssteuerung",
    chromaLightingControlsDetail3:
      'Du kannst schnell zwischen Chroma-Effekten wechseln, zum Beispiel "Zum nächsten Chroma Studio-Effekt wechseln"',
    closeText: "Schließen",
    LaunchApplication: "Anwendung starten",
    LaunChApplicationSubTitle:
      'Du kannst Anwendungen starten, zum Beispiel "Taschenrechner öffnen"',
    launchApplicationDetail1:
      "Zu den unterstützten Anwendungen zählen Internet-Browser, Media Player, Taskmanager, Snipping Tool, Paint, Editor, Rechner",
    MultimediaControls: "Multimedia-Steuerung",
    MultimediaControlsDetail1:
      'Du kannst die Lautstärke anpassen, zum Beispiel "Lautstärke auf 50 % senken"',
    basicLightingControlsDetail2:
      'Du kannst die Helligkeit auf einen bestimmten Wert erhöhen/senken, zum Beispiel:  "Chroma-Beleuchtung auf 50 % senken"',
    chromaLightingControlsDetail1:
      'Du kannst eine Basis-Effekt-Farbe wählen, zum Beispiel: "Chroma-Beleuchtung auf Atmung Grün setzen" oder "Chroma-Beleuchtung auf Durchlaufen des Farbspektrums setzen"',
    chromaLightingControlsDetail2:
      'Du kannst zu dem Chroma-Effekt wechseln, den du mit Razer Chroma Studio erstellt hast, zum Beispiel "Chroma-Beleuchtung auf Razer Chroma Studio-Effekt 1 setzen"',
    chromaLightingControlsDetail4:
      'Du kannst den Chroma Visualizer ein- und ausschalten, zum Beispiel "Chroma Visualizer einschalten"',
    chromaLightingControlsDetail5:
      'Du kannst eine Chroma Party starten, zum Beispiel "Chroma Party starten"',
    MultimediaControlsDetail2:
      'Du kannst die Stummschaltung ein- und ausschalten, zum Beispiel "Stummschalten"',
    MultimediaControlsDetail3:
      'Du kannst das Mikrofon ein- und ausschalten, zum Beispiel "Mikrofon stummschalten"',
    MultimediaControlsDetail4:
      'Du kannst die Mikrofon-Lautstärke anpassen, zum Beispiel mit "Mikrofon-Lautstärke auf 50 %"',
    PowerControls: "Stromversorgung",
    PowerControlsDetail:
      'Du kannst deinen Computer herunterfahren oder sperren, indem du beispielsweise "PC herunterfahren" sagst.',
    smartHomeSkillsControls: "Smart Home Skills",
    smartHomeSkillsControlsDetail:
      'Du kannst die Chroma-Beleuchtung spontan auf jeden Effekt oder jede Farbe setzen, zum Beispiel mit "<b>Chroma-Beleuchtungseffekt auf Statisch (Grün)</b> setzen"',
    smartHomeSkillsControlsDetail1:
      '"Chroma-Beleuchtungseffekt auf Statisch (Grün) setzen"',
    smartHomeSkillsControlsDetail2:
      '"Chroma-Beleuchtungseffekt auf Durchlaufen des Farbspektrums"',
    smartHomeSkillsControlsDetail3:
      '"Chroma-Beleuchtungshelligkeit auf (50 %)"',
    smartHomeSkillsControlsDetail4:
      '"Chroma-Beleuchtungshelligkeit erhöhen/verringern"',
    smartHomeSkillsControlsDetail5: '"Chroma-Beleuchtung an/aus"',
    canUseAlexa: "Du kannst nun Alexa verwenden.",
    someThingToTry: "Hier einige Sachen, die du mal ausprobieren kannst:",
    someThingToTryDetail1: '"Wie ist das Wetter?" ',
    someThingToTryDetail2: '"Chroma-Beleuchtungshelligkeit auf 50 %"',
    someThingToTryDetail3:
      '"Chroma-Beleuchtungseffekt auf Durchlaufen des Farbspektrums"',
    someThingToTryDetail4: '"Wie hoch ist der Mount Everest?"',
    someThingToTryDetail5: '"Razer soll den Browser öffnen"',
    someThingToTryDetail6: '"Razer soll meinen PC sperren"',
    someThingToTryDetail7: '"Razer eine Chroma Party starten lassen"',
    notLoginSubTitleLine1:
      "Mit Alexa kannst du per Sprachbefehl Musik wiedergeben und dir Updates zu News, Sport, Ergebnissen, Wetter und noch mehr holen.",
    notLoginSubTitleLine2: "Dazu musst du nur Alexa fragen.",
    wheneverCommands:
      "Klicke dazu einfach auf die Alexa-Taste unter deinem Avatar, um Fragen zu stellen und Anweisungen zu geben.",
    canUseAlexaHotkeyToActivate:
      " Du kannst auch mit der Tastenkombination Strg + Umschalt + A Alexa aktivieren. ",
    settingsToolTip1:
      "Du kannst Alexas Einstellungen anpassen, etwa App-Sounds und visuelle Inhalte, Aktivierungskürzel, Anzeigesprache und erkannte Eingabegeräte.",
    settingsToolTip2:
      "Hinweis: Wenn du Alexa deaktivierst, wird Alexa auf diesem Gerät nicht mehr zuhören oder sprechen. ",
    settingsToolTip3:
      "Synapse Skills bleibt auch dann aktiv, wenn Alexa deaktiviert ist.",
    loginWithAlexa: "MIT AMAZON ANMELDEN",
    notUserFront: "Du bist gar nicht ",
    notUserBack: "?",
    appSound: "App-Sounds",
    displayCard: "Display-Karten",
    razerIDRequired: "EINE RAZER ID IST ERFORDERLICH",
    mustLogin:
      "Bitte melde dich mit deiner Razer ID, um dieses Modul nutzen zu können.",
    logIn: "ANMELDEN",
    isEnableWakeWord: 'Indem du das Weckwort  "Alexa" sagst',
    isEnableShortCut: "Mit einem Tastaturkürzel",
    accountLinkingConflictsDialogParam1:
      "Dieses Amazon-Konto ist bereits mit einem anderen Razer Konto verknüpft. Eine Kontoverknüpfung ist nötig, damit Alexa Razer Synapse über ein Gerät mit Alexa-Unterstützung steuern kann.",
    accountLinkingConflictsDialogParam2:
      'Hinweis: Wähle "Zulassen", um die vorhandene Verbindung von Razer Konto und Amazon-Konto zu entfernen.',
    accountLinkingConflictsDialogOK: "ZULASSEN",
    accountLinkingConflictsDialogCancel: "ABBRECHEN",
    loginSessionExpireLine1: "Anmelde-Sitzung beendet.",
    loginSessionExpireLine2:
      "Dieses Amazon-Konto ist bereits woanders mit einem anderen Razer Konto angemeldet",
    SupportedRegions: "Unterstützte Regionen",
    VoiceNote:
      "Hinweis: Die Spracherkennung wird besser, wenn du von Amazon zertifizierte Eingabegeräte einsetzt.",
    AlexaGuide: "Alexa Benutzerhandbuch & FAQ",
    CodebasedLinking: {
      instruction1: "Öffne",
      instruction2:
        "auf deinem Smartphone, Computer oder Tablet und gib diesen Code ein:",
    },
  },
  [AppString.es_ES]: {
    alexa: "ALEXA",
    audio: "AUDIO",
    language: "IDIOMA HABLADO DE ALEXA",
    inputDevice: "Dispositivo de entrada",
    activateShortcut: "Activa el atajo de teclado para Alexa",
    setRespond: "Define el idioma en el que te comunicarás con Alexa.",
    account: "CUENTA",
    signOut: "Cerrar sesión",
    doNotDisturb: "NO MOLESTAR",
    doNotDisturbDetail1:
      "Apaga todos los sonidos, las notificaciones de estado y las tarjetas de visualización.",
    settings: "AJUSTES",
    skills: "SKILLS",
    home: "INICIO",
    noNetwork: "No se ha detectado conectividad de red.",
    speaking: "Hablando",
    micOff: "Micrófono desactivado",
    thinking: "Pensando",
    noMic: "Sin micrófono",
    listening: "Escuchando",
    sessionTimeout: "La sesión se ha cerrado. ",
    loginToContinue: "Inicia sesión para continuar.",
    stopResponse: "Detener la respuesta",
    StopAndCloseWindow: "Detener y cerrar esta ventana",
    alexaButton: "Botón Alexa",
    synapseSkill: "SKILL DE SYNAPSE",
    synapseSkillDetail:
      "Gracias a la skill de Synapse y a Alexa, ahora puedes controlar tu ordenador y tus dispositivos Razer Chroma solo con tu voz.",
    synapseSkill1: "SKILLS PERSONALIZADAS",
    synapseSkillDetail1:
      'Te recomendamos que navegues hasta la skill de Razer diciendo "Abre Razer" seguido de una de las skills que figuran más abajo.',
    synapseSkill2: "SKILLS PARA TU SMART HOME",
    synapseSkillDetail2:
      'En la aplicación de Alexa estará disponible un dispositivo con "iluminación Chroma". <br/>Para activar estas skills, basta con decir "Alexa" seguido del comando con el nombre del dispositivo con "iluminación Chroma".',
    basicLightingControls: "Controles básicos de iluminación",
    basicLightingControlsDetail1:
      'Puedes encender/apagar dispositivos; por ejemplo con: "Activa la iluminación Chroma"',
    expandText: "Más skills",
    chromaLightingControls: "Controles de iluminación Chroma",
    chromaLightingControlsDetail3:
      'Puedes cambiar con rapidez entre tus efectos Chroma; por ejemplo con: "Cambia al próximo efecto Chroma Studio"',
    closeText: "Cerrar",
    LaunchApplication: "Abrir aplicación",
    LaunChApplicationSubTitle:
      'Puedes abrir aplicaciones; por ejemplo con: "Abre calculadora"',
    launchApplicationDetail1:
      "Entre las aplicaciones compatibles se incluyen: navegador web, reproductor de medios, administrador de tareas, herramienta de recorte, bloc de notas y calculadora",
    MultimediaControls: "Controles multimedia",
    MultimediaControlsDetail1:
      'Puedes aumentar/reducir el volumen; por ejemplo con: "Reduce el volumen al 50 %"',
    basicLightingControlsDetail2:
      'Puedes cambiar el brillo a tenue/fuerte o ajustarlo a un valor específico; por ejemplo con:  "Baja la iluminación Chroma al 50 %"',
    chromaLightingControlsDetail1:
      'Puedes establecer un color de efecto básico; por ejemplo con: "Activa la iluminación Chroma en verde respiración" o "Activa la iluminación Chroma en rotación de espectro"',
    chromaLightingControlsDetail2:
      'Puedes cambiar al efecto Chroma que hayas creado en Chroma Studio; por ejemplo con: "Activa la iluminación Chroma en el efecto 1 de Chroma Studio"',
    chromaLightingControlsDetail4:
      'Puedes encender/apagar Chroma Visualizer; por ejemplo con: "Enciende Chroma Visualizer"',
    chromaLightingControlsDetail5:
      'Para iniciar una fiesta Chroma, basta con que digas: "Inicia una fiesta Chroma"',
    MultimediaControlsDetail2:
      'Puedes activar/desactivar el volumen; por ejemplo con: "Desactiva el volumen"',
    MultimediaControlsDetail3:
      'Puedes activar/desactivar el micrófono; por ejemplo con: "Desactiva el micrófono"',
    MultimediaControlsDetail4:
      'Puedes subir/bajar el volumen del micrófono; por ejemplo: "Cambia el volumen del micrófono al 50 %"',
    PowerControls: "Alimentación",
    PowerControlsDetail:
      'Puedes apagar o bloquear tu ordenador; por ejemplo: "Apaga mi PC"',
    smartHomeSkillsControls: "Skills para tu smart home",
    smartHomeSkillsControlsDetail:
      'Puedes establecer rápidamente cualquier efecto o color de la iluminación Chroma; por ejemplo: "Activa el <b>efecto de iluminación Chroma</b> en <b>verde estático</b>".',
    smartHomeSkillsControlsDetail1:
      '"Activa el efecto de iluminación Chroma en estático (verde)"',
    smartHomeSkillsControlsDetail2:
      '"Activa el efecto de iluminación Chroma en rotación de espectro"',
    smartHomeSkillsControlsDetail3:
      '"Activa el brillo de la iluminación Chroma al (50 %)"',
    smartHomeSkillsControlsDetail4:
      '"Aumenta/reduce el brillo de la iluminación Chroma"',
    smartHomeSkillsControlsDetail5: '"Activa/desactiva la iluminación Chroma"',
    canUseAlexa: "Ahora puedes usar Alexa.",
    someThingToTry: "Aquí tienes más ideas que puedes probar:",
    someThingToTryDetail1: '"¿Qué tiempo hace?" ',
    someThingToTryDetail2: '"Pon el brillo de la iluminación Chroma al 50 %"',
    someThingToTryDetail3:
      '"Activa el efecto de iluminación Chroma en rotación de espectro"',
    someThingToTryDetail4: '"¿Cuánto mide el Everest?"',
    someThingToTryDetail5: '"Pídele a Razer que abra el navegador web"',
    someThingToTryDetail6: '"Pídele a Razer que bloquee el PC"',
    someThingToTryDetail7: '"Dile a Razer que inicie una fiesta Chroma"',
    notLoginSubTitleLine1:
      "Usa tu voz con Alexa para escuchar música y recibir información de noticias, deportes, resultados, el tiempo y mucho más.",
    notLoginSubTitleLine2:
      "Lo único que tienes que hacer es preguntarle a Alexa.",
    wheneverCommands:
      "Cuando estés listo, haz clic en el botón Alexa situado junto a tu avatar para preguntarle o darle órdenes.",
    canUseAlexaHotkeyToActivate:
      " Para activar Alexa, también puedes usar el atajo de teclado predeterminado Ctrl + Shift + A. ",
    settingsToolTip1:
      "Puedes cambiar ciertos ajustes de Alexa, como los sonidos y el contenido visual de la aplicación, los atajos de activación, el idioma seleccionado y el dispositivo de entrada reconocido.",
    settingsToolTip2:
      "Nota: Si desactivas Alexa, no podrá escucharte ni hablarte en este dispositivo.",
    settingsToolTip3:
      "Las skills de Synapse seguirán activas incluso aunque desactives Alexa.",
    loginWithAlexa: "INICIAR SESIÓN CON AMAZON",
    notUserFront: "¿No eres ",
    notUserBack: "?",
    appSound: "Sonidos de la aplicación",
    displayCard: "Tarjetas de visualización",
    razerIDRequired: "ES NECESARIA UNA RAZER ID",
    mustLogin: "Debes iniciar sesión con tu Razer ID para usar esta función.",
    logIn: "INICIAR SESIÓN",
    isEnableWakeWord: "Con tu voz diciendo la palabra de activación «Alexa»",
    isEnableShortCut: "Con un atajo de teclado",
    accountLinkingConflictsDialogParam1:
      "Esta cuenta de Amazon ya se ha vinculado a otra cuenta Razer diferente. Es necesario vincular la cuenta para permitir a Alexa controlar tu Razer Synapse a través de un dispositivo compatible.",
    accountLinkingConflictsDialogParam2:
      "Nota: Si pulsas «Permitir» la cuenta de Razer actual se desvinculará de tu cuenta de Amazon.",
    accountLinkingConflictsDialogOK: "PERMITIR",
    accountLinkingConflictsDialogCancel: "CANCELAR",
    loginSessionExpireLine1: "Sesión finalizada.",
    loginSessionExpireLine2:
      "Se ha iniciado sesión en la cuenta de Amazon en otra parte con una cuenta de Razer diferente",
    SupportedRegions: "Regiones compatibles",
    VoiceNote:
      "Nota: el reconocimiento de voz mejora al utilizar dispositivos de entrada certificados por Amazon.",
    AlexaGuide: "Guía y preguntas frecuentes sobre Alexa",
    CodebasedLinking: {
      instruction1: "Visita",
      instruction2:
        "en tu teléfono inteligente, ordenador o tableta e introduce este código:",
    },
  },
  [AppString.fr_FR]: {
    alexa: "ALEXA",
    audio: "SON",
    language: "LANGUE DE COMMANDE VOCALE ALEXA",
    inputDevice: "Dispositif d'entrée",
    activateShortcut: "Activer le raccourci Alexa",
    setRespond: "Définir la langue à laquelle Alexa écoutera et répondra.",
    account: "COMPTE",
    signOut: "Se déconnecter",
    doNotDisturb: "NE PAS DÉRANGER",
    doNotDisturbDetail1:
      "Désactiver tous les sons, notifications d'état et cartes d'affichage.",
    settings: "PARAMÈTRES",
    skills: "SKILLS",
    home: "ACCUEIL",
    noNetwork: "Aucune connexion réseau détectée.",
    speaking: "Parle",
    micOff: "Micro éteint",
    thinking: "Pense",
    noMic: "Pas de micro",
    listening: "Écoute",
    sessionTimeout: "Expiration de la session. ",
    loginToContinue: "Veuillez vous connecter pour continuer.",
    stopResponse: "Arrêter la réponse",
    StopAndCloseWindow: "Arrêter et fermer cette fenêtre",
    alexaButton: "Bouton Alexa",
    synapseSkill: "SKILL SYNAPSE",
    synapseSkillDetail:
      "Grâce à la skill Synapse et à Alexa, vous pouvez désormais contrôler votre ordinateur ainsi que vos périphériques Razer Chroma rien qu’en leur parlant.",
    synapseSkill1: "SKILLS PERSONNALISÉES",
    synapseSkillDetail1:
      "Nous vous recommandons de naviguer vers le skill Razer en disant « Ouvrir Razer », puis en indiquant l’un des skills ci-dessous.",
    synapseSkill2: "SKILLS DE MAISON CONNECTÉE",
    synapseSkillDetail2:
      "Un appareil compatible avec l’« Éclairage Chroma » sera disponible sur l’application Alexa <br/>Ces fonctions peuvent être activées en prononçant d’abord « Alexa », puis la commande accompagnée du nom de l’appareil « Éclairage Chroma ».",
    basicLightingControls: "Commandes d'éclairage de base",
    basicLightingControlsDetail1:
      "Vous pouvez allumer ou éteindre vos périphériques, en disant par exemple : « Allume l'éclairage Chroma »",
    expandText: "Plus de skills",
    chromaLightingControls: "Commandes d'éclairage Chroma",
    chromaLightingControlsDetail3:
      "Vous pouvez passer rapidement d'un effet Chroma à un autre, en disant par exemple : « Passe au prochain effet Chroma Studio »",
    closeText: "Fermer",
    LaunchApplication: "Lancer une application",
    LaunChApplicationSubTitle:
      "Vous pouvez lancer une application en disant par exemple : « Lance la calculatrice »",
    launchApplicationDetail1:
      "Les applications prises en charge incluent les navigateurs Web, les lecteurs multimédias, les gestionnaires de tâche, les outils de capture, Paint, le Bloc-notes et la calculatrice",
    MultimediaControls: "Commandes multimédias",
    MultimediaControlsDetail1:
      "Vous pouvez augmenter / diminuer le volume en disant par exemple : « Baisse le volume à 50 % »",
    basicLightingControlsDetail2:
      "Vous pouvez augmenter/diminuer la luminosité, ou la définir à un niveau spécifique, en disant par exemple :  « Réduis l'éclairage Chroma à 50 % »",
    chromaLightingControlsDetail1:
      "Vous pouvez définir un effet coloré de base, par exemple : « Définis l'éclairage Chroma sur Vert respirant » ou « Définis l'éclairage Chroma sur Cycle de spectre »",
    chromaLightingControlsDetail2:
      "Vous pouvez activer un effet Chroma que vous avez créé dans Chroma Studio, par exemple : « Définis l'éclairage Chroma sur l'Effet Chroma Studio 1 »",
    chromaLightingControlsDetail4:
      "Vous pouvez allumer ou éteindre Chroma Visualizer, en disant par exemple : « Allume Chroma Visualizer »",
    chromaLightingControlsDetail5:
      "Vous pouvez lancer une Chroma Party en disant « Démarre une Chroma Party »",
    MultimediaControlsDetail2:
      "Vous pouvez couper/rétablir le volume en disant par exemple : « Coupe le volume »",
    MultimediaControlsDetail3:
      "Vous pouvez couper/rétablir le micro en disant par exemple : « Coupe le micro »",
    MultimediaControlsDetail4:
      "Vous pouvez augmenter/diminuer le volume du microphone en disant par exemple : « Met le volume à 50 % »",
    PowerControls: "Alimentation",
    PowerControlsDetail:
      "Vous pouvez éteindre ou verrouiller votre ordinateur, en disant par exemple : « Éteins mon PC ».",
    smartHomeSkillsControls: "Skills de maison connectée",
    smartHomeSkillsControlsDetail:
      "Vous pouvez rapidement définir l’éclairage Chroma pour n’importe quel effet ou couleur (par exemple, « Définir l’<b>effet d’éclairage Chroma</b> sur <b>vert statique</b> »).",
    smartHomeSkillsControlsDetail1:
      "« Définir l’effet d’éclairage Chroma sur (vert) statique »",
    smartHomeSkillsControlsDetail2:
      "« Définir l’effet d’éclairage Chroma sur cycle de spectre »",
    smartHomeSkillsControlsDetail3:
      "« Définir la Luminosité de l’éclairage Chroma (50 %) »",
    smartHomeSkillsControlsDetail4:
      "« Augmenter/Diminuer la Luminosité de l’éclairage Chroma »",
    smartHomeSkillsControlsDetail5: "« Activer/Désactiver l’éclairage Chroma »",
    canUseAlexa: "Alexa est prête à l'utilisation.",
    someThingToTry: "Voici certaines choses que vous pourriez essayer :",
    someThingToTryDetail1: "«Quel temps fait-il ? » ",
    someThingToTryDetail2:
      "« Définir la Luminosité de l’éclairage Chroma à 50 % »",
    someThingToTryDetail3:
      "« Définir l’effet d’éclairage Chroma sur cycle de spectre »",
    someThingToTryDetail4: "« Quelle taille fait le mont Everest ? »",
    someThingToTryDetail5:
      "« Demander à Razer d’ouvrir un navigateur Internet »",
    someThingToTryDetail6: "« Demander à Razer de verrouiller mon PC »",
    someThingToTryDetail7: "« Dire à Razer de Démarrer une Chroma Party »",
    notLoginSubTitleLine1:
      "Alexa vous permet d'utiliser votre voix pour jouer de la musique, vous tenir au courant des informations, des résultats sportifs, des prévisions météorologiques, et bien plus encore.",
    notLoginSubTitleLine2: "Il vous suffit de demander à Alexa.",
    wheneverCommands:
      "Lorsque vous serez prêt, cliquez sur le bouton Alexa situé juste à côté de votre avatar pour lui poser des questions, ou lui donner des instructions.",
    canUseAlexaHotkeyToActivate:
      " Vous pouvez également utiliser le raccourci par défaut Ctrl+ Maj + A pour activer Alexa. ",
    settingsToolTip1:
      "Modifiez certains paramètres d'Alexa tels que ses applications sonores et son contenu visuel, son raccourci d'activation, sa langue d'affichage, et le périphérique de saisie reconnu.",
    settingsToolTip2:
      "Remarque : Alexa ne pourra plus écouter ou parler à ce périphérique si vous la désactivez. ",
    settingsToolTip3:
      "Les skills Synapse resteront actives même après la désactivation d'Alexa.",
    loginWithAlexa: "CONNEXION AVEC AMAZON",
    notUserFront: "Vous n'êtes pas ",
    notUserBack: "?",
    appSound: "Applications sonores",
    displayCard: "Afficher les cartes",
    razerIDRequired: "UN RAZER ID EST REQUIS",
    mustLogin:
      "Vous devez vous connecter avec votre Razer ID pour utiliser ce module.",
    logIn: "CONNEXION",
    isEnableWakeWord: "Vocalement en disant le mot d’activation « Alexa »",
    isEnableShortCut: "Avec un raccourci clavier",
    accountLinkingConflictsDialogParam1:
      "Ce compte Amazon est déjà associé à un compte Razer différent. Vous devez associer vos comptes afin de permettre à Alexa de contrôler votre Razer Synapse par le biais d’un appareil compatible avec Alexa.",
    accountLinkingConflictsDialogParam2:
      "Remarque : en cliquant sur « Autoriser », vous supprimerez le compte Razer déjà associé à votre compte Amazon.",
    accountLinkingConflictsDialogOK: "AUTORISER",
    accountLinkingConflictsDialogCancel: "ANNULER",
    loginSessionExpireLine1: "Fin de la session de connexion.",
    loginSessionExpireLine2:
      "Une connexion à ce compte Amazon a eu lieu ailleurs avec un compte Razer différent",
    SupportedRegions: "Régions prises en charge",
    VoiceNote:
      "Remarque : La reconnaissance vocale s'améliore si vous utilisez des appareils d’entrée certifiés Amazon.",
    AlexaGuide: "Guide Alexa et FAQ",
    CodebasedLinking: {
      instruction1: "Rendez-vous sur",
      instruction2:
        "sur votre smartphone, ordinateur, ou tablette, puis saisissez ce code:",
    },
  },
  [AppString.ja_JP]: {
    alexa: "ALEXA",
    audio: "オーディオ",
    language: "ALEXA スピーチ言語",
    inputDevice: "入力デバイス",
    activateShortcut: "Alexa ショートカットのアクティブ化",
    setRespond: "Alexa が聞いて答える言語を設定します。",
    account: "アカウント",
    signOut: "サインアウト",
    doNotDisturb: "通知オフ",
    doNotDisturbDetail1:
      "すべてのサウンド、ステータス通知、カード表示をオフにします。",
    settings: "設定",
    skills: "スキル",
    home: "ホーム",
    noNetwork: "ネットワーク接続が検出されませんでした。",
    speaking: "スピーキング",
    micOff: "マイクオフ",
    thinking: "シンキング",
    noMic: "マイクなし",
    listening: "リスニング",
    sessionTimeout: "セッションのタイムアウト。 ",
    loginToContinue: "続行するにはログインしてください。",
    stopResponse: "応答の停止",
    StopAndCloseWindow: "停止し、このウィンドウを閉じます",
    alexaButton: "Alexa ボタン",
    synapseSkill: "SYNAPSE スキル",
    synapseSkillDetail:
      "Synapse スキルと Alexa でコンピュータと Razer Chroma デバイスを音声でコントロールできます。",
    synapseSkill1: "カスタムスキル",
    synapseSkillDetail1:
      "Razer スキルに移動するには「Razer を開いて」と言ってから、以下のスキルを続けて指定することをお勧めします。",
    synapseSkill2: "スマートホームスキル",
    synapseSkillDetail2:
      "「Chroma ライティング」デバイスは Alexa アプリで使用できます。 <br/>このスキルは「Alexa」と呼びかけた後に「Chroma ライティング」デバイス名と一緒にコマンドを伝えるだけで動作します。",
    basicLightingControls: "基本ライティングコントロール",
    basicLightingControlsDetail1:
      "「Chroma ライティングをオンにして」など、デバイスのオン/オフを切り替えます。",
    expandText: "その他のスキル",
    chromaLightingControls: "Chroma ライティングコントロール",
    chromaLightingControlsDetail3:
      "「次の Chroma Studio 効果に切り替えて」など、Chroma 効果を素早く切り替えることができます。",
    closeText: "閉じる",
    LaunchApplication: "アプリケーションを起動",
    LaunChApplicationSubTitle:
      "「計算機を起動して」など、アプリケーションを起動できます。",
    launchApplicationDetail1:
      "サポートされているアプリケーションには、Web ブラウザー、メディアプレーヤー、タスクマネージャー、Snipping Tool、ペイント、メモ帳、電卓があります。",
    MultimediaControls: "マルチメディアコントロール",
    MultimediaControlsDetail1:
      "「音量を 50% に下げて」など、音量を上げたり下げたりできます。",
    basicLightingControlsDetail2:
      "明るさを変更して明るくしたり暗くしたり、「Chroma ライティングを 50% まで暗くして」など、  特定の値に設定できます。",
    chromaLightingControlsDetail1:
      "「Chroma ライティングを緑で素早く点滅に設定して」、または「Chroma ライティングをスペクトラムサイクリングに設定して」など、基本的な効果色を設定できます。",
    chromaLightingControlsDetail2:
      "「Chroma ライティングを Chroma Studio 効果 1 に設定して」など、Chroma Studio で作成した Chroma 効果に切り替えることができます。",
    chromaLightingControlsDetail4:
      "「Chroma Visualizer をオンにして」など、Chroma Visualizer のオン/オフを切り替えることができます。",
    chromaLightingControlsDetail5:
      "「Chroma パーティーを開始して」など、Chroma パーティーを開始できます。",
    MultimediaControlsDetail2:
      "「音量をミュートして」など、音量のミュート機能のオン/オフを切り替えることができます。",
    MultimediaControlsDetail3:
      "「マイクをミュートして」など、マイクのミュート機能のオン/オフを切り替えることができます。",
    MultimediaControlsDetail4:
      "「マイクの音量を 50% に変更して」などと言って、マイクの音量を上げたり下げたりできます。",
    PowerControls: "電源",
    PowerControlsDetail:
      "「PC をシャットダウンして」などと言って、コンピュータをシャットダウンまたはロックすることができます。",
    smartHomeSkillsControls: "スマートホームスキル",
    smartHomeSkillsControlsDetail:
      "Chroma ライティングを任意のエフェクトや色に素早く設定できます。たとえば、「<b>Chroma ライティング効果をスタティックグリーン</b>に設定」などと伝えます。",
    smartHomeSkillsControlsDetail1:
      "「Chroma ライティング効果をスタティック (グリーン) に設定」",
    smartHomeSkillsControlsDetail2:
      "「Chroma ライティング効果をスペクトラムサイクリングに設定」",
    smartHomeSkillsControlsDetail3:
      "「Chroma ライティングの明るさ を (50%) にして」",
    smartHomeSkillsControlsDetail4:
      "「Chroma ライティングの明るさを上げる/下げる」",
    smartHomeSkillsControlsDetail5: "「Chroma ライティングのオン/オフ」",
    canUseAlexa: "これで Alexa を使用することができます。",
    someThingToTry: "いくつか試してみてください：",
    someThingToTryDetail1: "「天気は？」 ",
    someThingToTryDetail2: "「Chroma ライティングの明るさ を 50% にして」",
    someThingToTryDetail3:
      "「Chroma ライティング効果をスペクトラムサイクリングに設定」",
    someThingToTryDetail4: "「エベレストの高さは？」",
    someThingToTryDetail5: "「ウェブブラウザを開くように Razer に伝えて」",
    someThingToTryDetail6: "「PC をロックするように Razer に伝えて」",
    someThingToTryDetail7: "「Chroma パーティーを開始するよう Razer に伝えて」",
    notLoginSubTitleLine1:
      "Alexa により音声を使用して音楽を再生したり、ニュース、スポーツ、スコア、天気などの情報を取得できます。",
    notLoginSubTitleLine2: "Alexa に尋ねるだけです。",
    wheneverCommands:
      "準備ができたら、アバターのそばにある Alexa ボタンをクリックして質問するかコマンドを伝えます。",
    canUseAlexaHotkeyToActivate:
      " また、デフォルトのショートカット Ctrl + Shift + A を使用して Alexa をアクティブ化できます。 ",
    settingsToolTip1:
      "アプリの音、ビジュアルコンテンツ、アクティブ化ショートカット、表示言語、認識された入力デバイスといった Alexa の設定を変更します。",
    settingsToolTip2:
      "注：Alexa を無効にすると、Alexa はこのデバイスで聞いたり話したりする機能を停止します。",
    settingsToolTip3:
      "Synapse スキルは Alexa が無効の場合でも有効のままになります。",
    loginWithAlexa: "AMAZON でログイン",
    notUserFront: "",
    notUserBack: "ではありませんか？",
    appSound: "アプリの音",
    displayCard: "表示カード",
    razerIDRequired: "RAZER ID が必要です",
    mustLogin:
      "このモジュールを使用するには Razer ID でログインする必要があります。",
    logIn: "ログイン",
    isEnableWakeWord: "起動ワード「Alexa（アレクサ）」と発声",
    isEnableShortCut: "キーボードショートカット使用",
    accountLinkingConflictsDialogParam1:
      "この Amazon アカウントは他の Razer アカウントにすでにリンクされています。Alexa が対応デバイスで Razer Synapse をコントロールするにはアカウントのリンクが必要です。",
    accountLinkingConflictsDialogParam2:
      "注：押すことにより、Amazon アカウントにリンクされた既存の Razezr アカウントが削除されます。",
    accountLinkingConflictsDialogOK: "許可",
    accountLinkingConflictsDialogCancel: "キャンセル",
    loginSessionExpireLine1: "ログインセッション終了。",
    loginSessionExpireLine2:
      "この Amazon アカウントは別の場所から他の Razer アカウントでログインされています。",
    SupportedRegions: "サポート範囲",
    VoiceNote:
      "注：Amazon 認定の入力デバイスを使用すると、音声認識が向上します。",
    AlexaGuide: "Alexa ガイドと FAQ",
    CodebasedLinking: {
      instruction1: "スマートフォン、コンピューター、またはタブレットで ",
      instruction2: "にアクセスし、次のコードを入力してください。",
    },
  },
});

export const LocalizationContext = React.createContext(
  strings // default value
);
